module.exports = __webpack_public_path__ + "static/media/p_27_2.fc1b4dcf.png";